import { render } from "./GiftButton.vue?vue&type=template&id=2e6b8df5&scoped=true"
import script from "./GiftButton.vue?vue&type=script&lang=js"
export * from "./GiftButton.vue?vue&type=script&lang=js"

import "./GiftButton.vue?vue&type=style&index=0&id=2e6b8df5&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6b8df5"]])

export default __exports__